import React from 'react';
import { CreateEditEstimateNavEnum } from 'containers/estimates/constants';
import classnames from 'classnames';
import { twMerge } from 'tailwind-merge';

interface CreateEstimateSidebarProps {
  activeTab: CreateEditEstimateNavEnum;
  onTabChange: (tab: CreateEditEstimateNavEnum) => void;
}

const CreateEstimateSidebar: React.FC<CreateEstimateSidebarProps> = ({ activeTab, onTabChange }) => {
  const tabs = [
    { label: CreateEditEstimateNavEnum.CUSTOMER },
    { label: CreateEditEstimateNavEnum.ESTIMATE_DETAILS },
    { label: CreateEditEstimateNavEnum.LINE_ITEMS },
    { label: CreateEditEstimateNavEnum.NOTES_ATTACHMENTS },
    { label: CreateEditEstimateNavEnum.MORE_OPTIONS }
  ];

  return (
    <div className="flex w-full flex-col 1439px:space-y-5">
      {tabs.map(tab => (
        <div
          key={tab.label}
          id={`create-estimate-side-nav-${tab.label.toLowerCase()}`}
          onClick={() => onTabChange(tab.label)}
          className={twMerge(
            'cursor-pointer rounded h-50 py-[15px] 1439px:py-4 pl-6 font-semibold text-[#3E556D]',
            classnames({ 'text-secondary ring-1 ring-secondary': activeTab === tab.label })
          )}>
          <div className="text-17px">{tab.label}</div>
        </div>
      ))}
    </div>
  );
};

export default CreateEstimateSidebar;
